"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.services = exports.knowledgeBaseArticleService = exports.queryClient = void 0;
const knowledge_base_article_1 = require("./knowledge-base-article");
var query_client_1 = require("./query-client");
Object.defineProperty(exports, "queryClient", { enumerable: true, get: function () { return query_client_1.queryClient; } });
var knowledge_base_article_2 = require("./knowledge-base-article");
Object.defineProperty(exports, "knowledgeBaseArticleService", { enumerable: true, get: function () { return knowledge_base_article_2.knowledgeBaseArticleService; } });
exports.services = [knowledge_base_article_1.knowledgeBaseArticleService];
